import React, { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import VinDetailHeaderActions from '../../components/HeaderActions/VinDetailHeaderActions';
import Header from '../../components/Header/Header';
import ContentLayout from '../../components/ContentLayout';
import VinDetails, { type VinDetailsState } from './VinDetails';

function VinDetailsPage() {
  const { vinId } = useParams<{ vinId: string }>();
  const [searchParams] = useSearchParams();
  const inspectionId = searchParams.get('inspectionId') ?? undefined;
  const inspectionDateTime = searchParams.get('inspectionDateTime') ?? undefined;
  const [vinDetailsState, setVinDetailsState] = useState<VinDetailsState>({
    data: undefined,
    loading: true,
    error: null,
  });

  return (
    <>
      <Header
        title="VIN Details"
        headerActions={
          <VinDetailHeaderActions data={vinDetailsState.data} loading={vinDetailsState.loading} error={vinDetailsState.error} />
        }
      />
      <ContentLayout>
        <VinDetails
          vin={vinId}
          mode="page"
          initialInspectionId={inspectionId}
          initialInspectionDateTime={inspectionDateTime}
          onStateChange={setVinDetailsState}
        />
      </ContentLayout>
    </>
  );
}

export default VinDetailsPage;
